import { useQuery } from '@provision/graphql-client';
import { GET_CLIENT_GATEWAY_URL_QUERY } from './client-gateway-url.operations';

interface GetClientGatewayUrlQuery {
  getClientGatewayUrl: string;
}

/** The partner's Client Gateway: their active custom domain, else `myprovision.io/{slug}`. */
export const useClientGatewayUrl = (partnerId: number | null | undefined) => {
  const { data } = useQuery<GetClientGatewayUrlQuery>(GET_CLIENT_GATEWAY_URL_QUERY, {
    skip: partnerId === null || partnerId === undefined,
    variables: { input: { partnerId } },
  });

  return data?.getClientGatewayUrl ?? null;
};
